<script setup lang="ts">
import { computed } from 'vue'

const { icon = 'feather:plus',
  label,
  type = 'primary',
  disabled } = defineProps<{
  icon: string
  label: string
  type?: 'primary' | 'secondary' | 'outlined' | 'outlined-orange' | 'cancel' | 'warning' | 'error' | 'outlined-clear'
  disabled?: boolean
}>()

const style = computed(() => ({
  'bg-metras-blue text-white': type === 'primary',
  'bg-metras-green text-white': type === 'secondary',
  'bg-metras-orange text-white': type === 'warning',
  'bg-metras-lighter-blue text-metras-blue border border-metras-blue': type === 'outlined',
  'bg-metras-light-orange text-metras-orange border border-metras-orange': type === 'outlined-orange',
  'bg-metras-red text-white': type === 'cancel' || type === 'error',
  'bg-white text-metras-grey border border-metras-grey': type === 'outlined-clear',
  'opacity-40': disabled,
  'hover:opacity-60': !disabled
}))
</script>

<template>
  <button class="flex items-center flex-row gap-2 p-2 rounded-sm transition-opacity" :class="style" :disabled="disabled">
    <Icon class="text-2xl" :icon="icon" />
    <span class="text-sm"> {{ label }} </span>
  </button>
</template>

<style scoped></style>
